export default function ({ redirect }) {
  redirect(`${process.env.LOGIN_URL}?target=doctor`)
}
